module.exports = __webpack_public_path__ + "static/assets/91e5e882b27f472915f05f3c1dee7b76.svg";